import { DeliverySpeedDetail } from "@swiggy-private/cart-types";
import { getBridgeSdk } from "@swiggy-private/checkout-core";
import { GlobalHeaderState, SwgyHeaderType, SwgyHeadersList, SwgyHeadersKeys } from "@swiggy-private/checkout-core";

type Dict<T> = { [header: string]: T | undefined };

export const syncClientHeaders = async (): Promise<void> => {
    return getBridgeSdk()
        .getSwiggyHeadersDataFromClient()
        .then(headers => {
            if (!headers) {
                return;
            }

            const swgyHeaders: Dict<string> = {};
            for (const property in headers) {
                const value = headers[property];
                if (
                    typeof value === "string" &&
                    SwgyHeadersList.indexOf(property.toLowerCase() as SwgyHeadersKeys) !== -1
                ) {
                    swgyHeaders[property.toLowerCase()] = value;
                }
            }

            GlobalHeaderState.init(swgyHeaders as SwgyHeaderType);
            return;
        });
};

export const syncCartAddressHeaders = ({
    cartId,
    addressId,
}: {
    cartId: string | number;
    addressId: string | number;
}): void => {
    GlobalHeaderState.updateHeaders({
        cartaddressid: String(addressId),
        cartid: String(cartId),
    });
};

export const getSelectedSLA = (slaOptions: DeliverySpeedDetail[], selectedType: string): number | null => {
    const selectedOption = slaOptions.find(option => option.type === selectedType);
    return selectedOption ? selectedOption.sla : null;
};
